module.exports = __webpack_public_path__ + "static/media/vrptl-tpmc-full-video-v3_1m06-1m30_4.5x.f5c413cc.gif";